import axios from 'axios'
import { computed, unref } from 'vue'
import { getTaskListRouteContext } from '../config/taskListConfig.js'

const TASK_LISTS_ENDPOINT = '/api/v1/task-lists'

const mapPaginationState = (store, responseData) => {
  if (responseData.current_page) {
    store.page = responseData.current_page
    store.perPage = responseData.per_page
    store.total = responseData.total
    store.lastPage = responseData.last_page
    return
  }

  if (responseData.meta) {
    store.page = responseData.meta.current_page
    store.perPage = responseData.meta.per_page
    store.total = responseData.meta.total
    store.lastPage = responseData.meta.last_page
  }
}

/**
 * @param {import('pinia').StoreGeneric} tasksStore
 * @param {string|import('vue').Ref<string>|import('vue').ComputedRef<string>} context
 */
export function useTaskList(tasksStore, context) {
  const normalizedContext = computed(() => getTaskListRouteContext(unref(context)))

  const fetchTaskList = async (params = {}) => {
    tasksStore.isLoading = true
    tasksStore.error = null

    const queryParams = {
      page: tasksStore.page,
      per_page: tasksStore.perPage,
      order_by: tasksStore.orderBy,
      order_direction: tasksStore.orderDirection,
      ...params,
    }

    try {
      const { data } = await axios.get(`${TASK_LISTS_ENDPOINT}/${normalizedContext.value}`, {
        params: queryParams,
      })

      tasksStore.items = data.data || data
      mapPaginationState(tasksStore, data)

      return data
    } catch (error) {
      tasksStore.error = error
      throw error
    } finally {
      tasksStore.isLoading = false
    }
  }

  return {
    normalizedContext,
    fetchTaskList,
  }
}
